import styled from 'styled-components';
import { NoVideosIllustration } from '../../assets';

export const Container = styled.div`
  color: ${({ theme }) => theme.ga.gray};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 82vh;
  padding: 24px;
`;

export const Illustration = styled(NoVideosIllustration)`
  margin: 100px;
`;
